














import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import chipplyIcons from "@/chipply/ImportIcons";

@Component
export default class AppliedCodeChip extends Vue {
    @Prop({ default: String })
    public code!: string;

    @Prop({ default: String })
    public balance!: string;

    public chipplyIcons = chipplyIcons;
}
